<template>
  <div>
    <b-row>
      <b-col cols="3" sm="2">
        <b-img v-if="userDetails.collaboratorProfilePictureUrl" class="profile-picture" :src="userDetails.collaboratorProfilePictureUrl" rounded="circle"
               alt="User profile picture"></b-img>

        <b-img v-else class="profile-picture" :src="require('../../../../src/assets/default_profile.png')" rounded="circle"
               alt="User profile picture"></b-img>
      </b-col>
      <b-col :class="{'collaborator-list-area': homeSelectedComponent !== 'collaboratorDetails'}">
        <p class="collaborator-name-text">{{ userDetails.collaboratorName }}</p>
        <p class="collaborator-email-address-text">{{ userDetails.collaboratorEmail }}</p>
        <p v-if="userDetails.owner" class="collaborator-role-text">Role: {{ userDetails.collaborativeToDoListRole }} (Owner)</p>
        <p v-else class="collaborator-role-text">Role: {{ userDetails.collaborativeToDoListRole }}</p>
      </b-col>
    </b-row>
    <hr>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: "CollaboratorListCell",
    props: {
      userDetails: Object
    },
    computed: {
      ...mapGetters([
        "homeSelectedComponent"
      ])
    }
  }
</script>

<style scoped>
  .profile-picture {
    width: 5em;
    height: 5em;
  }

  .collaborator-name-text, .collaborator-email-address-text {
    margin-bottom: 0.5em;
  }

  .collaborator-role-text {
    margin-bottom: 0;
  }

  .collaborator-list-area {
    cursor: pointer;
  }

</style>
